import { createContext, useContext, useState, ReactNode } from "react";

interface EditModeContextType {
  isEditing: boolean;
  toggleEdit: () => void;
}

const EditModeContext = createContext<EditModeContextType | undefined>(undefined);

export const EditModeProvider = ({ children }: { children: ReactNode }) => {
  const [isEditing, setIsEditing] = useState(false);

  const toggleEdit = () => setIsEditing((prev) => !prev);

  return (
    <EditModeContext.Provider value={{ isEditing, toggleEdit }}>
      {children}
    </EditModeContext.Provider>
  );
};

export const useEditMode = () => {
  const context = useContext(EditModeContext);
  if (!context) throw new Error("useEditMode must be used within EditModeProvider");
  return context;
};
